import { atom, map } from "nanostores";

export const $modal = map({});

/**
 * Cart Model
 * @typedef {{
 *    id: string,
 *    productSku: string,
 *    name: string,
 *    image: string,
 *    price: number,
 *    promotionPrice: number,
 *    quantity: number,
 *    description: string
 *    variantTitle: string,
 * }} Cart
 */
export const $cart = atom([]);

/**
 * Product Model
 * @typedef {{
 *    promotionPrice: number,
 *    stockTagType: number,
 *    productSku: string,
 *    productLink: string,
 *    price: number,
 *    orderIndex: number,
 *    name: string,
 *    isPinned: boolean,
 *    description: string,
 *    discountPercentage: number,
 *    id: number,
 *    image: string,
 *    isSynced: boolean,
 *    options: Array
 *    variants: Array
 * }} Product
 */
export const $productDetail = atom(null);
export const $productExternalDetail = atom(null);

export const $selectedProductDetail = atom("");

export function initialModalState(videoId) {
	if ($modal.get()[videoId]) return;
	$modal.setKey(videoId, {
		openProductList: false,
		openProductDetail: false,
		openProductExternalDetail: false,
		openCart: false,
	});
}

export function toggleModal(videoId, state) {
	let modalState = $modal.get()[videoId];
	modalState = { ...modalState, ...state };
	$modal.setKey(videoId, modalState);
}

export function resetAllState(videoId) {
	$modal.setKey(videoId, {
		openProductList: false,
		openProductDetail: false,
		openProductExternalDetail: false,
		openCart: false,
	});
	$productDetail.set(null);
	$productExternalDetail.set(null)
}

export function addOrUpdateCart(cartItem) {
	const currentCart = $cart.get();
	const existItem = currentCart.find((item) => item.id === cartItem.id);
	if (existItem) {
		existItem.quantity = cartItem.quantity;
		$cart.set([...currentCart]);
	} else {
		$cart.set([...currentCart, cartItem]);
	}
}

export function deleteCart(variantId) {
	const currentCart = $cart.get();
	const newCart = currentCart.filter((item) => item.id !== variantId);
	if (currentCart.length !== newCart.length) {
		$cart.set([...newCart]);
	}
}
